// utils/epayco3ds.js
export async function ensureEpayco3DSScript(
  src = "https://multimedia.epayco.co/general/3DS/validateThreeds.min.js"
) {
  if (typeof window !== "undefined" && typeof window.validate3ds === "function") return;
  await new Promise((resolve, reject) => {
    const sc = document.createElement("script");
    sc.src = src;
    sc.async = true;
    sc.onload = resolve;
    sc.onerror = () => reject(new Error("No se pudo cargar el script 3DS"));
    document.body.appendChild(sc);
  });
}

export function requires3DS(transactionData) {
  return !!transactionData && transactionData["3DS"] !== undefined;
}

/**
 * Arma el payload en el FRONT y llama validate3ds(data3DS).
 * Devuelve una Promise que resuelve con el postMessage recibido.
 */
export async function process3DS(transactionData, timeoutMs = 180000) {
  await ensureEpayco3DSScript();

  if (!requires3DS(transactionData)) return null;

  const data3DS = {
    franquicia: transactionData.franquicia,
    "3DS":  transactionData["3DS"],
    ref_payco: transactionData.ref_payco,
    cc_network_response: transactionData.cc_network_response,
  };
  console.log('data3DS', data3DS);
  
  const expectedRef = data3DS.ref_payco;

  return new Promise((resolve, reject) => {
    const onMessage = (ev) => {
      const d = ev?.data || {};
      // ePayco suele enviar success/message y/o ref_payco
      if (d?.ref_payco === expectedRef || d?.success || d?.message) {
        window.removeEventListener("message", onMessage);
        clearTimeout(timer);
        resolve(d);
      }
    };

    const timer = setTimeout(() => {
      window.removeEventListener("message", onMessage);
      reject(new Error("Timeout esperando resultado 3DS"));
    }, timeoutMs);

    window.addEventListener("message", onMessage);
    // Aquí invocas EXACTAMENTE lo que piden:
    window.validate3ds(data3DS);
  });
}
